module.exports = __webpack_public_path__ + "media/images/press_kit/aman_at_sea/login/1_aman-18198c002fddba11e6bb7e57089faf3d.png";